"use client";

import { useI18n } from "@/i18n/I18nProvider";

type Scope = "account/signup" | "product/product" | "payment/crypto";

const scopeKeys = {
  "account/signup": "signup",
  "product/product": "checkout",
  "payment/crypto": "cryptoCheckout",
} as const;

/** Adapter for migrated screens: reads local dictionaries, never calls PHP or fetch. */
export function useScopedTranslations(scope: Scope) {
  const { messages, locale } = useI18n();
  const values = messages[scopeKeys[scope]] as Record<string, string>;
  return {
    locale,
    t: (key: string, fallback?: string): string => values[key] ?? fallback ?? key,
    isLoading: false,
    isError: null,
  };
}
